import React, { useEffect, useState } from 'react';
import API from '../api';
import { IcClock, IcFilter } from './Icons';

export default function Events() {
  const [events, setEvents] = useState([]);
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);

  useEffect(() => {
    API.get(`/events/school/1?date_filter=${date}`).then(r => setEvents(r.data)).catch(() => {});
  }, [date]);

  const entries  = events.filter(e => e.event_type === 'entry').length;
  const exits    = events.filter(e => e.event_type === 'exit').length;
  const unknowns = events.filter(e => !e.student && !e.teacher).length;
  const outside  = events.filter(e => e.inside_zone === false).length;

  return (
    <div style={{ padding: 28 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
        <div>
          <h1 className="page-title">Historique</h1>
          <p className="page-subtitle">{events.length} événement{events.length > 1 ? 's' : ''}</p>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <IcFilter size={15} stroke="var(--slate-400)" />
          <input type="date" value={date} onChange={e => setDate(e.target.value)}
            style={{ padding: '7px 10px', border: '1px solid var(--slate-200)', borderRadius: 8, fontSize: 13, color: 'var(--slate-700)', outline: 'none', background: '#fff' }} />
        </div>
      </div>

      {/* Mini stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 12, marginBottom: 20 }}>
        {[
          { label: 'Entrées', value: entries, color: 'var(--emerald)', bg: 'var(--emerald-l)' },
          { label: 'Sorties', value: exits, color: 'var(--amber)', bg: 'var(--amber-l)' },
          { label: 'Inconnus', value: unknowns, color: 'var(--red)', bg: 'var(--red-l)' },
          { label: 'Hors zone', value: outside, color: 'var(--orange)', bg: 'var(--orange-l)' },
        ].map(s => (
          <div key={s.label} className="card" style={{ padding: '14px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: 12, color: 'var(--slate-500)' }}>{s.label}</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: s.color }}>{s.value}</div>
          </div>
        ))}
      </div>

      <div className="card" style={{ overflow: 'hidden' }}>
        {events.length === 0 ? (
          <div className="empty">
            <IcClock size={40} stroke="var(--slate-300)" />
            <p style={{ marginTop: 12 }}>Aucun événement pour cette date</p>
          </div>
        ) : (
          <table>
            <thead>
              <tr><th>Heure</th><th>Personne</th><th>Type</th><th>Catégorie</th><th>Confiance</th><th>Zone</th></tr>
            </thead>
            <tbody>
              {events.map(e => {
                const name = e.student?.name || e.teacher?.name || e.unknown_person?.code || null;
                const sub  = e.student?.class || e.teacher?.subject || null;
                const isEntry   = e.event_type === 'entry';
                const isUnknown = !e.student && !e.teacher;
                const time = new Date(e.timestamp).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
                return (
                  <tr key={e.id}>
                    <td style={{ fontFamily: 'monospace', fontSize: 12, color: 'var(--slate-400)' }}>{time}</td>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div className={`avatar av-sm ${isUnknown ? 'av-red' : e.person_type === 'teacher' ? 'av-amber' : 'av-indigo'}`}>
                          {isUnknown ? '?' : name?.split(' ').map(w => w[0]).join('').slice(0,2).toUpperCase()}
                        </div>
                        <div>
                          <div style={{ fontWeight: 500, fontSize: 13, color: 'var(--slate-800)' }}>
                            {name || <span style={{ color: 'var(--red)' }}>Inconnu</span>}
                          </div>
                          {sub && <div style={{ fontSize: 11, color: 'var(--slate-400)' }}>{sub}</div>}
                        </div>
                      </div>
                    </td>
                    <td><span className={`badge ${isEntry ? 'badge-green' : 'badge-orange'}`}>{isEntry ? 'Entrée' : 'Sortie'}</span></td>
                    <td><span className={`badge ${e.person_type === 'student' ? 'badge-indigo' : e.person_type === 'teacher' ? 'badge-amber' : 'badge-red'}`}>
                      {e.person_type === 'student' ? 'Élève' : e.person_type === 'teacher' ? 'Enseignant' : 'Inconnu'}
                    </span></td>
                    <td>
                      {e.confidence
                        ? <span style={{ fontSize: 12, fontWeight: 600, color: e.confidence > 0.8 ? 'var(--emerald)' : e.confidence > 0.6 ? 'var(--amber)' : 'var(--red)' }}>
                            {(e.confidence * 100).toFixed(1)}%
                          </span>
                        : <span style={{ color: 'var(--slate-300)' }}>—</span>}
                    </td>
                    <td>
                      {e.inside_zone === false
                        ? <span className="badge badge-orange">Hors zone</span>
                        : e.inside_zone === true
                        ? <span className="badge badge-green">Dans zone</span>
                        : <span style={{ color: 'var(--slate-300)', fontSize: 12 }}>—</span>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
